import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';
import { UtilsService } from 'src/app/core/service/utils.service';
import { ProjectSettingService } from 'src/app/pages/projects/services/project-setting.service';
import { SettingsPageService } from '../../settings-service/settings-page.service';

@Component({
  selector: 'app-priority-modal',
  templateUrl: './priority-modal.component.html',
  styleUrls: ['./priority-modal.component.scss']
})
export class PriorityModalComponent implements OnInit {

  @ViewChild("modal") modal!: ElementRef;
  @Output() updateTable: EventEmitter<any> = new EventEmitter();

  projectId: number | null = null;
  modalTitle: string;

  priorityForm!: FormGroup;
  submitted: boolean = false;
  modalRef: NgbModalRef;
  loading: boolean = false;

  constructor(protected settingSrv: SettingsPageService,
    protected projSettingSrv: ProjectSettingService,
    protected modalService: NgbModal,
    protected fb: FormBuilder,
    public translateService: TranslateService,
    protected utilSrv: UtilsService) {
  }

  ngOnInit(): void {
    this.setForm();
  }

  get formPriority() { return this.priorityForm.controls; }

  setForm() {
    this.priorityForm = this.fb.group({
      Priority: ['', Validators.required],
      CustomerPriority: ['', Validators.required],
      Id: [0],
    });
  }

  openModal(type: string, data: any, projectId?: number) {
    this.loading = true;
    this.setForm();
    if (projectId) this.projectId = projectId;
    this.modalTitle = type === 'editPriority' ? 'SETTINGS.PRIORITY.EDITPRIORITY' : 'SETTINGS.PRIORITY.ADDPRIORITY';

    if (type === 'editPriority') this.fillForm(data);
    else this.loading = false;
    this.modalRef = this.modalService.open(this.modal, { centered: true, backdrop: 'static', keyboard: false });
  }

  fillForm(data: any) {

    this.priorityForm.controls['Id'].setValue(data.id);
    this.priorityForm.controls['Priority'].setValue(data.description);
    this.priorityForm.controls['CustomerPriority'].setValue(data.clientDescription);

    this.loading = false;
  }

  save() {
    this.submitted = true;
    if (this.priorityForm.valid) {
      const data: any = {
        type: 'PRIORITY',
        description: this.formPriority.Priority.value,
        clientDescription: this.formPriority.CustomerPriority.value,
      };

      if (this.projectId) {
        data['projectId'] = this.projectId;
      }

      const id = this.formPriority.Id.value;
      let request;
      if (this.projectId) {
        request = id === 0 ? this.projSettingSrv.createConfig(this.projectId, data) : this.projSettingSrv.updateConfig(this.projectId, id, data);
      } else request = id === 0 ? this.settingSrv.registerConfigurations(data) : this.settingSrv.updateConfiguration(data, id);

      request.pipe(finalize(() => {
        this.updateTable.emit();
      })).subscribe((data: any) => {
        this.utilSrv.notify(id === 0 ? 'SETTINGS.CREATED' : 'SETTINGS.UPDATED', 'success')
          .then(() => {
            this.setForm();
            this.submitted = false;
            this.modalRef.close();
          });
      }, (error: any) => {
        console.error('Save', error);
        this.utilSrv.notify('SETTINGS.ERROR', 'error');
      });
    }
  }

  closeModal() {
    this.submitted = false;
    this.priorityForm.reset();
    this.modalRef.close();
  }

}
